export default __webpack_public_path__ + "static/l2-hero-image-b0d344fc5142daa5dd8227b69e68419e.png";